import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

import { ConfigurationService } from '../configuration.service';
import { Project } from '../firestore-models/project';
import { ApiProject} from '../api-client-module';
import { AppConst } from '../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-project-dialog',
  templateUrl: './select-project-dialog.component.html',
  styleUrls: ['./select-project-dialog.component.css'],
  standalone: false,
})
export class SelectProjectDialogComponent implements OnInit {

  private projectsCollection!: AngularFirestoreCollection<Project>;
  projectsObservable!: Observable<Project[]>;
  projectsSubscribe!: Subscription;
  projectId: string;

  displayedColumns: string[] = ['position', 'select', 'id', 'name',];
  dataSource = new MatTableDataSource<Project>();
  selection = new SelectionModel<Project>(true, []);

  currentLang: string = 'ja';

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<SelectProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApiProject,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.projectsCollection = this.angularFirestore.collection<Project>(
      AppConst.FIRESTORE_PROJECTS, ref => ref.orderBy('project_id', 'asc'));
    this.projectsObservable = this.projectsCollection.valueChanges({ idField: 'id' });
    this.projectsSubscribe = this.projectsObservable.subscribe(projects => {
      let data = [];
      for (const project of projects) {
        data.push(project);
      }
      this.dataSource.data = data;
    });
    this.currentLang = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.projectsSubscribe.unsubscribe();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: Project): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'}`;
  }

  selectFiles() {
    let projects: Array<ApiProject> = new Array<ApiProject>();
    for (const row of this.dataSource.data) {
      if (this.selection.isSelected(row)) {
        const project: ApiProject = {
          id: row.id,
          project_id: row.project_id,
          project_name: row.project_name,
          project_desc: row.project_desc,
          enabled: row.enabled,
          use_trans_base_lang_ko: row.use_trans_base_lang_ko,
          use_trans_base_lang_yuehk: row.use_trans_base_lang_yuehk,
          use_trans_base_lang_zhcn: row.use_trans_base_lang_zhcn,
          use_trans_base_lang_zhtw: row.use_trans_base_lang_zhtw,
      };
        projects.push(project);
      }
    }
    this.dialogRef.close(projects);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return compare(a.project_id, b.project_id, isAsc);
        case 'name':
          return compare(a.project_name, b.project_name, isAsc);
        default:
          return 0;
      }
    });
  }

  applyFilter(event: Event) {
    this.selection.clear();
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
